import { h, Component } from "preact";
import { Item, Loader, Divider, Header, Image } from "semantic-ui-react";
import icons from "../../../../assets/icons";

import styles from "./HappinessOverview.scss";

export class HappinessOverview extends Component {
  preparePastEntries(happinessData) {
    let pastEntryComponents = [];
    let today = new Date();
    let todayRendered = false;
    let lastDay = new Date();

    happinessData.forEach(entry => {
      let entryDate = new Date(entry.date);
      if (entryDate.getDate() == today.getDate() && !todayRendered) {
        pastEntryComponents.push(<Divider horizontal>Today</Divider>);
        todayRendered = true;
      }
      if (entryDate.getDate() !== lastDay.getDate()) {
        pastEntryComponents.push(
          <Divider horizontal>{entryDate.toDateString()}</Divider>
        );
        lastDay = entryDate;
      }
      pastEntryComponents.push(
        <Item className={styles.moodItem}>
          <div className={styles.mobileData}>
            <div className={styles.date}>
              <p>
                {(entryDate.getHours() < 10 ? "0" : "") +
                  entryDate.getHours() +
                  ":" +
                  (entryDate.getMinutes() < 10 ? "0" : "") +
                  entryDate.getMinutes()}
              </p>
            </div>
            <div className={styles.ratingImage}>
              <Image id={styles.itemImage} src={icons[entry.rating - 1]} />
            </div>
          </div>
          <div className={styles.description}>
            <Header className={styles.itemDescription}>
              <p
                className={
                  entry.description
                    ? styles.itemDescription
                    : styles.emptyDescription
                }
              >
                {entry.description || "No description given"}
              </p>
            </Header>
          </div>
        </Item>
      );
    });

    return pastEntryComponents;
  }

  render() {
    const { happinessData, currentOverviewUser } = this.props;
    return happinessData && happinessData.data ? (
      <div className={styles.item}>
        <Item.Group unstackable className={styles.itemGroup}>
          {happinessData.data.length == 0 ? (
            <Item>
              <Item.Content>
                <Item.Header>
                  {`${
                    currentOverviewUser.first_name
                  } has not filled in the Happiness Meter yet`}
                </Item.Header>
              </Item.Content>
            </Item>
          ) : (
            this.preparePastEntries(happinessData.data)
          )}
        </Item.Group>
      </div>
    ) : (
      <Loader active indeterminate>
        Loading entries
      </Loader>
    );
  }
}

export default HappinessOverview;



// WEBPACK FOOTER //
// ./src/modules/diary/components/happinessOverview/HappinessOverview.js